export default function stepScrollDown(): void {
  window.scroll({
    top: document.getElementById('app')?.clientHeight ?? 0,
    behavior: 'smooth',
  });
}
